import type { MailboxInfo } from "owa-client-types";
import { getConfig } from "./config";

export default async function getMailboxInfoForTelemetry(mailboxInfo?: MailboxInfo): Promise<MailboxInfo | undefined> {
    if (mailboxInfo) {
        return mailboxInfo;
    }
    
    const config = getConfig();
    try {
        const moduleContextMailboxInfo = await config.getModuleContextMailboxInfo?.();
        if (moduleContextMailboxInfo) {
            return moduleContextMailboxInfo;
        }
    }
    catch {
        // Module context is optional telemetry context; use the global account fallback.
    }
    
    return config.getGlobalSettingsAccountMailboxInfo?.();
}
